import {useEffect} from 'react';

const SCROLL_CONTAINER_SELECTOR = '.ant-table-content, .ant-table-body';

const SCROLL_STEP = 60;

const TYPING_SELECTOR =
  'input, textarea, select, [contenteditable=""], [contenteditable="true"]';

const findScrollContainer = (node: unknown): HTMLElement | null => {
  return node instanceof Element
    ? node.closest<HTMLElement>(SCROLL_CONTAINER_SELECTOR)
    : null;
};

export const useTableKeyboardScroll = (): void => {
  useEffect(() => {
    let hoveredContainer: HTMLElement | null = null;

    const handleMouseOver = (event: MouseEvent) => {
      hoveredContainer = findScrollContainer(event.target);
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      const isLeft = event.key === 'ArrowLeft';

      if (
        (!isLeft && event.key !== 'ArrowRight') ||
        event.ctrlKey ||
        event.altKey ||
        event.metaKey ||
        event.shiftKey
      ) {
        return;
      }

      const target = event.target;

      if (target instanceof Element && target.closest(TYPING_SELECTOR)) {
        return;
      }

      const container =
        findScrollContainer(document.activeElement) ?? hoveredContainer;

      if (!container || container.scrollWidth <= container.clientWidth) {
        return;
      }

      event.preventDefault();
      container.scrollLeft += isLeft ? -SCROLL_STEP : SCROLL_STEP;
    };

    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};
